import WaitingSlider from "../waiting-slider/WaitingSlider";

interface LoadingProps {
  message?: string;
}

function Loading({message = "Loading..."}: LoadingProps) {
  return (
    <div className={"is-centered is-flex-column loading"}>
      <WaitingSlider
        size={"short"}
        bgColor={"gray-500"}
        customClassName={"loading__slider"}
      />

      {message && (
        <p className={"color--text-gray-lighter loading__message"}>{message}</p>
      )}
    </div>
  );
}

export default Loading;
